<script setup lang="ts">
	import { BellIcon, GiftIcon } from '@heroicons/vue/24/outline'
	import { computed } from 'vue'

	import useAuthUser from '@/composables/useAuthUser.ts'
	import useHasPermissionUser from '@/composables/useHasPermissionUser'

	import { Email } from '@/interfaces/email'
	import { NotificationSettings } from '@/interfaces/notificationSettings'

	import useEditUserNotifications from '@/modules/users/composables/useEditUserNotifications'

	import UserNotificationsForm from './UserNotificationsForm.vue'

	interface Props {
		userId: number
		title: string
		emails: Email[]
		mainEmail: string
		settings?: NotificationSettings
	}

	export interface ToggleValue {
		(
			value: string,
			category: keyof NotificationSettings,
			type: keyof NotificationSettings[keyof NotificationSettings]
		): void
	}

	const props = defineProps<Props>()

	const { mainEmail, userId, settings } = props

	const {
		form,
		transformedEmails,
		transformedPhones,
		toggleValue,
		handleSave,
	} = useEditUserNotifications(mainEmail, userId, settings)
</script>

<template>
	<div class="space-y-6">
		<!-- Header unificado -->
		<div class="bg-white rounded-lg shadow-sm border border-gray-200">
			<div class="px-6 py-4 border-b border-gray-200">
				<div class="flex items-center space-x-3">
					<div class="flex-shrink-0">
						<div
							class="w-8 h-8 bg-blue-100 rounded-lg flex items-center justify-center"
						>
							<BellIcon class="h-5 w-5 text-blue-600" />
						</div>
					</div>
					<div>
						<h2 class="text-lg font-medium text-gray-900">
							Configuración de Notificaciones
						</h2>
						<p class="text-sm text-gray-600">
							Elige cómo y dónde recibir las notificaciones importantes del
							sistema
						</p>
					</div>
				</div>
			</div>
		</div>

		<!-- Servicios del Sistema -->
		<div
			class="bg-white rounded-lg shadow-sm border border-gray-200 hover:border-blue-300 transition-all duration-200 hover:shadow-sm"
		>
			<div class="px-6 py-4 border-b border-gray-200">
				<div class="flex items-center space-x-3">
					<div class="flex-shrink-0">
						<div
							class="w-8 h-8 bg-blue-100 rounded-full flex items-center justify-center"
						>
							<BellIcon class="h-5 w-5 text-blue-600" />
						</div>
					</div>
					<h3 class="text-lg font-medium text-gray-900">
						Servicios del Sistema
					</h3>
				</div>
			</div>

			<div class="p-6">
				<UserNotificationsForm
					:user-id="userId"
					:settings="form.services"
					:phones="transformedPhones"
					:emails="transformedEmails"
					title="Servicios del Sistema"
					type="services"
					@toggle-value="toggleValue"
					@handle-save="handleSave"
				/>
			</div>
		</div>

		<!-- Incentivos y Ofertas -->
		<!-- <div
			class="bg-white rounded-lg shadow-sm border border-gray-200 hover:border-green-300 transition-all duration-200 hover:shadow-sm"
		>
			<div class="px-6 py-4 border-b border-gray-200">
				<div class="flex items-center space-x-3">
					<div class="flex-shrink-0">
						<div
							class="w-8 h-8 bg-green-100 rounded-full flex items-center justify-center"
						>
							<GiftIcon class="h-5 w-5 text-green-600" />
						</div>
					</div>
					<h3 class="text-lg font-medium text-gray-900">
						Incentivos y Ofertas
					</h3>
				</div>
			</div>

			<div class="p-6">
				<UserNotificationsForm
					:user-id="userId"
					:settings="form.incentives"
					:phones="transformedPhones"
					:emails="transformedEmails"
					title="Incentivos y Ofertas"
					type="incentives"
					@toggle-value="toggleValue"
					@handle-save="handleSave"
				/>
			</div>
		</div> -->

		<!-- Botón de guardar - Comentado porque ahora el guardado es automático -->
		<!-- 
    <div class="flex justify-end">
      <HasPermission name-permission="users" entity-type="update">
        <StyledButton
          :disabled="disableSave"
          :loading="updateUserLoading"
          @click="handleSave"
          class="bg-blue-600 hover:bg-blue-700 text-white px-6 py-2 rounded-lg font-medium transition-colors"
        >
          Guardar cambios
        </StyledButton>
      </HasPermission>
    </div>
    -->
	</div>
</template>

<style scoped></style>
